export default __webpack_public_path__ + "static/media/privacy-policy.7c0bb2dd.svg";